function getCookieValue(name) {
    var cookieArr = document.cookie.split('; ');
    var selectedCookie = cookieArr.find(function (cookie) {
        var cookieName = cookie.split('=')[0];
        return cookieName === name;
    });
    return selectedCookie ? decodeURIComponent(selectedCookie.split('=')[1] || '') : null;
}
export var getToken = function (tokenKey) {
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        var key = keyStructure[1];
        var value = null;
        if (keyStructure[0].toLocaleLowerCase() === 'localstorage') {
            value = localStorage.getItem(key);
            try {
                value = JSON.parse(value !== null && value !== void 0 ? value : '');
            }
            catch (e) {
                // If parsing fails, value stays as is
            }
        }
        else if (keyStructure[0].toLocaleLowerCase() === 'cookie') {
            value = getCookieValue(key);
        }
        // Remove any wrapping quotes and whitespace
        if (typeof value === 'string') {
            return value.replace(/^"|"$/g, '').trim();
        }
        return value;
    }
    return null;
};
export var getTokenDetails = function (tokenKey) {
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        return {
            type: keyStructure[0].toLocaleLowerCase(),
            key: keyStructure[1],
        };
    }
    return null;
};
